<template>
  <el-main v-loading="loading_main">
    <el-dialog title="选择发布字段" :visible.sync="publish_cols_show" width="700px"
               :close-on-click-modal="false">
      <el-transfer v-model="publish_cols" :data="data_cols" :titles="['数据字段','发布字段']"/>
      <br>
      <el-button style="width: 30%" type="primary" @click="publish_score(false)">确定</el-button>
    </el-dialog>
    <el-dialog title="新增考试成绩" :visible.sync="score_form_show" width="500px"
               :close-on-click-modal="false" v-loading="loading">
      <el-form label-width="80px" label-position="left" :model="score_form">
        <el-form-item label="考试名称" size="small">
          <el-input v-model="score_form.name" ref="score_form_name"/>
        </el-form-item>
        <el-form-item label="考试类型" size="small">
          <el-input v-model="score_form.exam_type" ref="score_form_exam_type"/>
        </el-form-item>
        <el-form-item label-width="0">
          <el-button type="success" icon="el-icon-upload" size="medium" @click="open_file_input">载入成绩
          </el-button>
          <input type="file" ref="upfile" accept=".xlsx, .xls" style="display: none"/>
        </el-form-item>
        <br>
        <el-form-item label-width="0">
          <el-button style="width: 30%" type="primary" @click="add_score">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-col :span="24" style="text-align: left;">
      <el-button-group>
        <el-button icon="el-icon-plus" type="warning" size="medium" @click="add_score_form_show">新增</el-button>
      </el-button-group>
    </el-col>
    <el-form inline size="mini">
      <el-form-item>
        考试名称：
        <el-input v-model="search_form.name" placeholder="名称" style="width: 120px;" clearable/>
      </el-form-item>
      <el-form-item>
        考试类型：
        <el-input v-model="search_form.exam_type" placeholder="类型" style="width: 120px;" clearable/>
      </el-form-item>
      <el-form-item>
        发布时间：
        <el-date-picker v-model="search_form.create_time_s" type="date" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :editable="false"
                        style="width: 140px;" placeholder="开始"/>
      </el-form-item>
      <el-form-item>
        -
        <el-date-picker v-model="search_form.create_time_e" type="date" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :editable="false"
                        style="width: 140px;" placeholder="结束"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query_score(true)">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-pagination
        background
        layout="prev, pager, next, sizes, total, jumper"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="page_size"
        :total="table_totle"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
    />
    <el-table
        :data="table_data"
        border
        fit
        size="mini"
        style="width: 100%">
      <el-table-column
          prop="name"
          label="名称"
          width="150px">
      </el-table-column>
      <el-table-column
          prop="exam_type"
          label="类型"
          width="150px">
      </el-table-column>
      <el-table-column
          prop="data_num"
          label="记录数"
          width="80px">
      </el-table-column>
      <el-table-column
          label="数据字段">
        <template slot-scope="scope">
          <el-tag v-for="(item,index) in scope.row['data_cols']" effect="dark" style="margin-left: 5px;"
                  :key="index"
                  size="mini">
            {{item}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          label="发布字段">
        <template slot-scope="scope">
          <el-tag v-for="(item,index) in scope.row['publish_cols']" effect="dark" style="margin-left: 5px;"
                  :key="index"
                  size="mini">
            {{item}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="创建时间"
          width="150px">
      </el-table-column>
      <el-table-column
          label="状态" width="140px">
        <template slot-scope="scope">
          <template v-if="scope.row['publish_flag']">
            <el-tag effect="dark" size="mini">已发布</el-tag>&nbsp;
            <template v-if="scope.row['publish_finish']">
              <el-tag effect="dark" size="mini">推送完成</el-tag>
            </template>
            <template v-else>
              <el-tag effect="dark" type="warning" size="mini">推送中</el-tag>
            </template>
          </template>
          <template v-else>
            <el-tag effect="dark" type="warning" size="mini">未发布</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          label="操作" width="250px" fixed="right">
        <template slot-scope="scope">
          <el-button-group>
            <el-button size="mini" :type="scope.row['publish_flag']?'warning':'success'"
                       @click="publish_score(scope.row)">
              <template v-if="scope.row['publish_flag']">取消</template>
              <template v-else>发布</template>
            </el-button>
            <el-button size="mini" type="primary" @click="preview(scope.row)">预览</el-button>
            <el-button size="mini" type="info" @click="show_score(scope.row)">导出</el-button>
            <el-button size="mini" type="danger" @click="del_score(scope.row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
  // @ is an alias to /src
  import global_ from "../global";
  import FileSaver from "file-saver";
  import XLSX from "xlsx";

  const admin_api = global_.admin_api;
  export default {
    name: 'score_manage',
    mounted() {
      this.$store.commit('set_current_url', "/score_manage")
    },
    created() {
      this.query_score()
    },
    data() {
      return {
        current_score: null,
        publish_cols_show: false,
        data_cols: [],
        publish_cols: [],
        loading: false,
        loading_main: false,
        page_num: 1,
        page_size: 10,
        table_totle: 0,
        search_form: {
          name: "",
          exam_type: "",
          create_time_s: "",
          create_time_e: ""
        },
        score_form: {
          name: "",
          exam_type: "",
          scores: []
        },
        score_form_show: false,
        table_data: []
      }
    },
    methods: {
      preview(v) {
        let publish_cols = v.publish_cols
        let publish_info = ""
        for (let col of publish_cols) {
          publish_info = publish_info + col + "：XX分 "
        }
        const h = this.$createElement;
        this.$msgbox({
          title: '格式阅览',
          message: h('p', null, [
            h('strong', null, 'XXX同学的成绩通知'),
            h('br'),
            h('strong', null, '考试名称：'),
            h('i', {style: 'color: teal'}, v.name),
            h('br'),
            h('strong', null, '考试类型：'),
            h('i', {style: 'color: teal'}, v.exam_type),
            h('br'),
            h('span', null, publish_info)
          ]),
          showConfirmButton: false,
          callback: () => {
          }
        });
      },
      handleCurrentChange(v) {
        this.page_num = v
        this.query_score()
      },
      handleSizeChange(v) {
        this.page_size = v
        this.query_score()
      },
      query_score(is_new = false) {
        if (is_new) {
          this.page_num = 1
        }
        let request_data = {
          service_name: 'query_score',
          page_num: this.page_num,
          page_size: this.page_size,
          search_form: this.search_form
        }
        this.axios.post(admin_api, request_data).then(response => {
          this.table_data = response.data['result_info']['table_data']
          this.table_totle = response.data['result_info']['table_totle']
        })
      },
      publish_score(v) {
        if (!v) {
          if (this.publish_cols.length === 0) {
            this.$message({message: '请选择发布字段', duration: 1000, type: 'error'})
            return false
          }
          v = this.current_score
          v['publish_cols'] = []
          for (let i of this.publish_cols) {
            v['publish_cols'].push(v['data_cols'][i])
          }
          let request_data = {
            service_name: 'publish_score',
            score_form: v
          }
          this.axios.post(admin_api, request_data).then(response => {
            let response_data = response.data
            this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
            this.publish_cols_show = false
            this.query_score()
          })
        } else if (!v['publish_flag']) {
          this.current_score = v
          this.data_cols = []
          for (let i in v['data_cols']) {
            this.data_cols.push({
              key: i, label: v['data_cols'][i], disabled: false
            })
          }
          this.publish_cols = []
          this.publish_cols_show = true
        } else {
          let request_data = {
            service_name: 'publish_score',
            score_form: v
          }
          this.axios.post(admin_api, request_data).then(response => {
            let response_data = response.data
            this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
            this.query_score()
          })
        }

      },
      show_score(v) {
        this.$nextTick(() => {
          this.loading_main = true
        })
        let request_data = {
          service_name: 'show_score',
          score_form: v
        }
        fetch(admin_api, {
          method: 'POST', // or 'PUT'
          body: JSON.stringify(request_data), // data can be `string` or {object}!
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => res.blob()).then(blob => {
          FileSaver.saveAs(blob, "1.xlsx");
          this.loading_main = false
        })
      },
      del_score(v) {
        let request_data = {
          service_name: 'del_score',
          score_form: v
        }
        this.axios.post(admin_api, request_data).then(response => {
          let response_data = response.data
          this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
          this.query_score()
        })
      },
      add_score_form_show() {
        this.score_form = {
          name: "",
          exam_type: "",
          scores: []
        }
        this.score_form_show = true
      },
      open_file_input() {
        this.$refs.upfile.value = ""
        this.$refs.upfile.click()
      },
      add_score() {
        if (this.score_form.name.length < 2) {
          this.$message({message: "请输入考试名称", duration: 1000, type: 'error'})
          this.$refs.score_form_name.focus()
          return false
        }
        if (this.score_form.exam_type.length < 2) {
          this.$message({message: "请输入考试类型", duration: 1000, type: 'error'})
          this.$refs.score_form_exam_type.focus()
          return false
        }
        let file = this.$refs.upfile.files[0]
        if (!file) {
          this.$message({message: "请选择成绩文件", duration: 1000, type: 'error'})
          return false
        }
        let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extension0 = testmsg === "xls";
        const extension = testmsg === "xlsx";
        const isLt2M = file.size / 1024 / 1024 < 100;
        if (!extension && !extension0) {
          this.$message({message: "上传文件只能是xls或xlsx格式!", duration: 1000, type: 'error'})
          return false;
        }
        if (!isLt2M) {
          this.$message({message: "上传文件大小不能超过 100MB!", duration: 1000, type: 'error'})
          return false;
        }
        let fileReader = new FileReader();
        fileReader.onloadstart = () => {
          this.$nextTick(() => {
            this.loading = true
          })
        }
        fileReader.onloadend = () => {
          if (this.score_form.scores.length === 0) {
            this.$message({message: "文件异常", duration: 1000, type: 'error'})
          } else {
            let request_data = {service_name: 'add_score', score_form: this.score_form}
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
              this.score_form_show = false
              this.query_score()
              this.loading = false
            })
          }
        }
        fileReader.onload = e => {
          let data = e.target.result;
          let wb = XLSX.read(data, {
            type: "binary"
          });
          let sheet = wb.Sheets[wb.SheetNames[0]];
          let range = XLSX.utils.decode_range(sheet["!ref"])
          let header_row_num = range.s.r
          let header_col_num_s = range.s.c
          let addr = XLSX.utils.encode_col(header_col_num_s) + XLSX.utils.encode_row(header_row_num);
          if (sheet[addr].v === "学号") {
            this.score_form.scores = XLSX.utils.sheet_to_json(sheet, {
              header: 1,
              raw: false
            });
          } else {
            this.score_form.scores = []
          }
        }
        fileReader.readAsBinaryString(file);

      }
    },
    components: {}
  }
</script>
